export const VERSION = '20221208.2';